import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { filter } from "rxjs/operators";
import { TemplateFacade } from "src/app/services/template.facade";
import { SubSink } from "subsink";
import { Circulation, ICirculationTemplate } from "../../interfaces";
import { LogClass } from "../../logger/log.classdecorater";
import { Logger } from "../../logger/logger";
import { NavigationService } from "../../services/navigation.service";

@LogClass({ source: "EditTemplateComponent" })
@Component({
    selector: "temp-edit-temp",
    templateUrl: "./edit.component.html",
    styleUrls: ["./edit.component.scss"],
    standalone: false
})
export class EditTemplateComponent implements OnInit {
  private logger: Logger;
  private subscriptions = new SubSink();

  public circulation: Circulation;
  @Input()
  @Output()
  public template: ICirculationTemplate;
  @Output()
  public abort = new EventEmitter<void>();
  @Output()
  public save = new EventEmitter<ICirculationTemplate>();
  public form = new FormGroup({
    title: new FormControl("", [Validators.required]),
    titleCirc: new FormControl("", [Validators.required]),
    demand: new FormControl("", [Validators.required])
  });
  public isReady = false;

  constructor(
    private templateFacade: TemplateFacade,
    private navigate: NavigationService
  ) {}

  public ngOnInit(): void {
    this.isReady = false;
    this.subscriptions.sink = this.templateFacade
      .getCurrentTemplate()
      .pipe(filter((t) => !!t))
      .subscribe(
        (t) => {
          this.logger.info("loaded template:" + t.id);
          this.isReady = true;
          this.template = t;

          this.setupForm();
        },
        (err) => {
          this.logger.error("loading template", err);
          this.isReady = true;
          this.navigate.toError(err);
        }
      );
  }

  private setupForm() {
    this.form.setValue({
      title: this.template.title,
      titleCirc: this.template.circulationTitle,
      demand: this.template.payload.demand
    });
  }

  public saveTemplate(): void {
    this.form.markAllAsTouched();

    if (!this.form.valid) {
      return;
    }
    this.template.title = this.form.value.title;
    this.template.circulationTitle = this.form.value.titleCirc;
    this.template.payload.demand = this.form.value.demand;

    this.subscriptions.sink = this.templateFacade
      .save(this.template)
      .subscribe((id) => {
        this.logger.info("saved template:" + id);
        this.navigate.toTemplate(id);
      });
  }

  public cancel(): void {
    this.navigate.toTemplate(this.template.id);
  }
}
